import { calculateEventTop, calculateEventHeight } from "@/lib/calendarPositioning";

interface ConflictEvent {
  id: string;
  startTime: Date;
  endTime: Date;
  highestConflictSeverity?: string;
}

interface ConflictBarsProps {
  events: ConflictEvent[];
  dayStart?: number;
}

export function ConflictBars({ events, dayStart = 0 }: ConflictBarsProps) {
  return (
    <>
      {/* CRITICAL conflicts (red diagonal stripes) */}
      {events
        .filter(ev => ev.highestConflictSeverity?.toLowerCase() === "critical")
        .map(ev => {
          const top = calculateEventTop(new Date(ev.startTime), dayStart);
          const height = calculateEventHeight(new Date(ev.startTime), new Date(ev.endTime));
          
          return (
            <div
              key={`critical-${ev.id}`}
              className="absolute left-0 right-0 rounded-sm pointer-events-none"
              style={{
                top: `${top}px`,
                height: `${height}px`,
                backgroundImage:
                  "repeating-linear-gradient(45deg, rgba(239, 68, 68, 0.5) 0, rgba(239, 68, 68, 0.5) 6px, transparent 6px, transparent 12px)",
              }}
              title="Critical conflict"
              data-testid={`conflict-bar-critical-${ev.id}`}
            />
          );
        })}

      {/* HIGH severity conflicts (yellow diagonal stripes) */}
      {events
        .filter(ev => ev.highestConflictSeverity?.toLowerCase() === "high")
        .map(ev => {
          const top = calculateEventTop(new Date(ev.startTime), dayStart);
          const height = calculateEventHeight(new Date(ev.startTime), new Date(ev.endTime));
          
          return (
            <div
              key={`high-${ev.id}`}
              className="absolute left-0 right-0 rounded-sm pointer-events-none"
              style={{
                top: `${top}px`,
                height: `${height}px`,
                backgroundImage:
                  "repeating-linear-gradient(45deg, rgba(234, 179, 8, 0.5) 0, rgba(234, 179, 8, 0.5) 6px, transparent 6px, transparent 12px)",
              }}
              title="High severity conflict"
              data-testid={`conflict-bar-high-${ev.id}`}
            />
          );
        })}
    </>
  );
}
